import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function FireList({ fires, testId = "fire-list" }) {
  if (!fires) {
    return <div className="label-mono py-4" data-testid={`${testId}-loading`}>Loading…</div>;
  }
  if (!fires.length) {
    return <div className="text-sm text-zinc-600 py-4" data-testid={`${testId}-empty`}>Nothing sent yet.</div>;
  }
  return (
    <div className="divide-y divide-zinc-200 max-h-[50vh] overflow-y-auto" data-testid={testId}>
      {fires.map((f) => (
        <div key={f.id} className="py-2 text-xs" data-testid={`${testId}-row`} data-ok={f.ok ? "yes" : "no"}>
          <div className="flex flex-wrap items-center gap-2">
            <span className={`font-bold uppercase tracking-widest text-[10px] ${f.ok ? "text-emerald-700" : "text-red-700"}`}>
              {f.ok ? "OK" : "Failed"}{f.status_code ? ` ${f.status_code}` : ""}
            </span>
            <span className="border border-black px-1 text-[10px] uppercase tracking-widest">{f.event}</span>
            {f.test && <span className="bg-amber-200 px-1 text-[10px] uppercase tracking-widest">Test</span>}
            {f.attempt > 0 && (
              <span className="border border-zinc-500 px-1 text-[10px] uppercase tracking-widest" data-testid={`${testId}-attempt`}>
                Retry {f.attempt} of {f.retries_total || 4}
              </span>
            )}
            {f.gave_up && <span className="bg-red-600 text-white px-1 text-[10px] uppercase tracking-widest" data-testid={`${testId}-gave-up`}>Gave up</span>}
            <span className="text-zinc-500">{new Date(f.at).toLocaleString()}</span>
          </div>
          {f.error && <div className="text-red-700 mt-0.5">{f.error}</div>}
          {f.will_retry_at && (
            <div className="text-amber-800 mt-0.5" data-testid={`${testId}-next-retry`}>Will try again {new Date(f.will_retry_at).toLocaleString()}</div>
          )}
          <div className="font-mono text-[11px] text-zinc-700 break-all mt-0.5">{f.url}</div>
        </div>
      ))}
    </div>
  );
}

export function FireLogDialog({ title, fires, onClose }) {
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="rounded-none border-2 border-black sm:max-w-2xl" data-testid="fire-log-dialog">
        <DialogHeader>
          <DialogTitle className="font-chivo text-xl font-black">{title}</DialogTitle>
        </DialogHeader>
        <FireList fires={fires} />
      </DialogContent>
    </Dialog>
  );
}
